var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layer',{ref:"layer"},[_vm._l((_vm.imageConfigs),function(img){return _c('v-image',{key:img.id,attrs:{"config":img}})}),_c('v-rect',{ref:"grid",attrs:{"config":_vm.gridRectConfig}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }